import { createLogger } from "../../common/createLogger.ts";
import type { LogEventShowOptions } from "../../common/types.ts";
import { toWorker } from "./toWorker.ts";

const saveEvent = () => {
	throw new Error("UI events should not be saved to DB");
};

// Toasts are a poor fit for this mobile UI, so we never pop them — no success/info/error/headline
// popups at all. We still run the one meaningful side effect of a persistent alert (halting game
// sim) so critical problems like an undersized roster still pause the sim, just without a toast.
// Events are unaffected in the League headlines feed; this only governs the transient popups.
export const showEvent = ({ persistent }: LogEventShowOptions) => {
	if (persistent) {
		toWorker("main", "getLocal", "autoPlayUntil").then((autoPlayUntil) => {
			if (!autoPlayUntil) {
				toWorker("main", "lockSet", ["stopGameSim", true]);
			}
		});
	}
};

export const logEvent = createLogger(saveEvent, showEvent);
